const $inject = ['$q', '$http', 'moment', 'APP_CONFIG', 'locationService', 'ENUMS'];

const itinerariesService = function ($q, $http, moment, APP_CONFIG, locationService, ENUMS) {
  let service = {
    itinerary: undefined,
    get: getItinerary,
    set,
    save,
    post,
    find,
    reset,
    getCurrentSearch,
    getStayLength,
    searchItineraries,
    locationSearch,
    addItems,
    updateSearch,
    postSearch,
    getPolicyOptions,
    deleteSector,
    groupPost,
    nextStage,
    totalPaxInCurrentSearch,
    invalidSeatsForSector,
    isUsingRailCard,
    getLoyaltyPrograms,
    getCarSupplierLocations,
    getFareRules,
    postMembership,
    deleteMembership,
    getApprovers,
    getPassengerApprovers,
    getCompanyReferences,
    getDepartments,
    getCostCentres,
    putFlight,
    putRail,
    computePaxFlightTotalAmount,
    computePaxSectors,
    deletePax,
    computeItinerary,
    requiresApproval,
    isChanging
  };

  function isChanging() {
    return service.itinerary.ChangeStatus === 'Changing';
  }

  function getCurrentSearch(searchIdentifier) {
    const currentSearchType = locationService.currentSearchType;

    if (searchIdentifier) {
      return service.itinerary.Search[`${currentSearchType}s`].find(searchItem => searchItem.Identifier === searchIdentifier);
    } else {
      const currentSearchIndex = locationService.searchIndex[currentSearchType];
      return service.itinerary.Search[`${currentSearchType}s`][currentSearchIndex];
    }
  }

  function getStayLength(hotelSearch) {
    const checkinMoment = moment(hotelSearch.DateFrom);
    const checkoutMoment = moment(hotelSearch.DateTo);

    return checkoutMoment.diff(checkinMoment, 'days');
  }

  function getPolicyOptions(searchIdentifier) {
    return getCurrentSearch(searchIdentifier).Policy;
  }

  function totalPaxInCurrentSearch() {
    return getCurrentSearch().Passengers.length;
  }

  function updateSearch(searchType, searchIndex, search) {
    if (Number.isInteger(searchIndex)) {
      if (searchType === 'Cars') {
        service.itinerary.Search[searchType][searchIndex] = search;
      } else {
        _.merge(service.itinerary.Search[searchType][searchIndex], search);
      }
    } else if (_.isArray(search)) {
      _.forEach(search, (newSearch, searchIndex) => {
        _.merge(service.itinerary.Search[searchType][searchIndex], newSearch);
      })
    }

    set(service.itinerary);

    return service.itinerary.Search;
  }

  function postSearch(updatedSearch) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itinerarySearch', service.itinerary.Identifier);

    $http.post(apiConfig.url, updatedSearch, {apiVersion:apiConfig.version})
      .then((res) => {
        let data = res.data;
        service.itinerary.Search = data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function set(itinerary) {
    service.itinerary = Array.isArray(itinerary) ? itinerary[0] : itinerary;
    window.svelteStore.setItineraryId('search', service.itinerary.Identifier);
  }

  function getItinerary(id) {
    let deferred = $q.defer();
    let itineraryId = null;

    if (id) {
      itineraryId = id;
    } else {
      const sessionItineraryId = window.svelteStore.getItineraryId('search');
      itineraryId = sessionItineraryId ? sessionItineraryId : window.itineraryId;
    }

    const apiConfig = window.svelteStore.apiConfig('itinerary', {
      itineraryId: itineraryId
    });

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then(function (res) {
        let data = res.data;
        
        if (data) {
          const itineraryData = _.isArray(data) ? data[0] : data;
          service.set(itineraryData, false);
          deferred.resolve(itineraryData);
        } else {
          deferred.reject();
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function searchItineraries(params) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itinerary');

    $http.get(apiConfig.url, { params: params, apiVersion: apiConfig.version })
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }


  function post(data, id, skipNext) {
    let deferred = $q.defer();

    const apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId: id });

    $http.post(apiConfig.url, data, { apiVersion: apiConfig.version })
      .then(function (res) {
        let data = res.data;
        service.set(data);

        if (!skipNext) {
          nextStage();
        }

        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function save(data, id) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId: id });

    $http.put(apiConfig.url, data, { apiVersion: apiConfig.version })
      .then(function(res) {
        let data = res.data;
        deferred.resolve(data)
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function find(itineraryId, passengerId) {
    let deferred = $q.defer();

    const apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId, passengerId });

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then(function (res) {
        let data = res.data;
        service.set(data);
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function reset() {
    window.svelteStore.removeItineraryId('search');
    window.svelteStore.removeItineraryId('manage');
    window.svelteStore.removeItineraryId('confirmation');
    service.itinerary = {};
  }

  function getFareRules(params) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', params, 'farerules');

    $http.get(apiConfig.url, {apiVersion: apiConfig.version})
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function locationSearch(params) {
    let deferred = $q.defer();

    $http.get(`${APP_CONFIG.api.url}${params.type}/locations/${params.maxRows}/${params.term}`, {
      desc: 'retrieving Airport locations from the server'
    })
      .then(function (res) {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function groupPost(id, items, type) {
    let searchIndexKey;
    let searchIndexIncrement = 1;

    switch (type) {
      case 'Hotels':
        searchIndexKey = 'Hotel';

        break;

      case 'Flights':
        searchIndexKey = 'Flight';

        searchIndexIncrement = service.itinerary.Search.Flights.length;

        break;

      case 'Rails':
        searchIndexKey = 'Rail';

        searchIndexIncrement = service.itinerary.Search.Rails.length;

        break;

      case 'Cars':
        searchIndexKey = 'Car';

        break;

      default:
        console.warn('No postType supplied')
    }

    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryPassenger', { itineraryId: id });

    $http.post(apiConfig.url, items, { apiVersion: apiConfig.version })
      .then((res) => {
        let data = res.data;
        if (searchIndexKey === 'Flight' && service.itinerary.Search.Flights.length === 2 && service.itinerary.Search.Cars.length > 0) {
          service.get(service.itinerary.Id).then(() => {
            locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement);
            nextStage();
          });
        } else {
          service.itinerary.Passengers = data;
          locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement);
          nextStage();
        }
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function deleteSector(itineraryId, passengerId, sectorId, sectorType) {
    let apiConfig = null;

    switch (sectorType) {
      case 'Flights':
        apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', { itineraryId, passengerId, sectorId });
        break;
      case 'Hotels':
        apiConfig = window.svelteStore.apiConfig('itineraryPassengerHotel', { itineraryId, passengerId, sectorId });
        break;
      case 'Rails':
        apiConfig = window.svelteStore.apiConfig('itineraryPassengerRail', { itineraryId, passengerId, sectorId });
        break;
      case 'Cars':
        apiConfig = window.svelteStore.apiConfig('itineraryPassengerCar', { itineraryId, passengerId, sectorId });
        break;
      default:
        console.warn('No postType supplied')
    }

    const deferred = $q.defer();

    $http.delete(apiConfig.url, { apiVersion: apiConfig.version })
      .then(() => {
        getItinerary(itineraryId).then(() => {
          deferred.resolve();
        });
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function addItems(items, type) {
    let passengers = service.itinerary.Passengers;

    angular.forEach(service.itinerary.Search.Passengers, passenger => {
      let id = passenger.Identifier;
      let targetPassenger = _.find(passengers, o => {
        return o.Identifier === id;
      });

      targetPassenger[type] = _.concat(targetPassenger[type], items);
    });

    return {
      itineraryId: service.itinerary.Identifier,
      items: items,
      type: type
    };
  }

  function nextStage() {
    locationService.nextPage(service.itinerary.Search, service.isChanging());
  }

  function invalidSeatsForSector(sector) {
    let invalidSeats = [];

    if (sector.Seat && sector.Seat.Status === 'Failed') {
      invalidSeats.push(flight.Seat);
    }

    _.forEach(flight.Stops, (stop) => {
      if (stop.Seat.Status === 'Failed') {
        invalidSeats.push(stop.Seat);
      }
    });

    return invalidSeats;
  }

  function isUsingRailCard() {
    return _.some(service.itinerary.Search.Rails, (railSearch) => {
      return railSearch.RailCardCode;
    });
  }

  function getLoyaltyPrograms(query) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('loyaltyProgram');

    $http.get(apiConfig.url, {params: {'q': query}, apiVersion: apiConfig.version})
      .then(function (res) {
        let data = res.data;
        if (data) {
          const mappedData = data.map(data => {
            data.TypeTitleValue = `${data.Type}:${data.Title}:${data.Value}`;
            return data;
          });
          deferred.resolve(mappedData);
        } else {
          deferred.reject();
        }
      })
      .catch(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getCarSupplierLocations(cityCode) {
    const path = 'api/Car/depots?citycode=' + cityCode;
    return $http.get(APP_CONFIG.api.root + path);
  }

  function postMembership(traveler, membership) {
    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerMembership', { itineraryId: traveler.ItineraryIdentifier, passengerId: traveler.Identifier });
    return $http.post(apiConfig.url, membership, { apiVersion: apiConfig.version });
  }

  function deleteMembership(traveler, membership) {
    const data = {};
    angular.copy(membership, data);
    delete data.traveler;
    delete data.requestDelete;

    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerMembership', { itineraryId: traveler.ItineraryIdentifier, passengerId: traveler.Identifier });

    return $http({
      method: 'DELETE',
      url: apiConfig.url,
      data: data,
      apiVersion: apiConfig.version
    });
  }

  function getApprovers(itineraryId) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryApprovers', itineraryId);

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then((res) => {
        let data = res.data;
        if (data) {
          const approvers = data.map(approver => {
            approver.fullName = approver.FirstName + ' ' + approver.LastName;
            return approver;
          });
          deferred.resolve(approvers);
        } else {
          deferred.reject();
        }
    });

    return deferred.promise;
  }

  function getPassengerApprovers(itineraryId) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryApprovers', itineraryId);

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then((res) => {
        let data = res.data;
        if (data) {
          deferred.resolve(data);
        } else {
          deferred.reject();
        }
    });

    return deferred.promise;
  }

  function getCompanyReferences(itineraryId) {
    const deferred = $q.defer();
    const apiConfig = window.svelteStore.apiConfig('itineraryCompanyReference', itineraryId);

    $http.get(apiConfig.url,{apiVersion:apiConfig.version}).then((res) => {
      let data = res.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function getDepartments(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/Department/';
    $http.get(APP_CONFIG.api.root + path).then((res) => {
      let data = res.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function getCostCentres(itineraryId) {
    let deferred = $q.defer();

    const path = 'api/itinerary/' + itineraryId + '/CostCentre/';
    $http.get(APP_CONFIG.api.root + path).then((res) => {
      let data = res.data;
      if (data) {
        deferred.resolve(data);
      } else {
        deferred.reject();
      }
    });

    return deferred.promise;
  }

  function putFlight(itineraryId, paxId, flightSectorId, flightSector) {
    let deferred = $q.defer();

    $http.put(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/Passenger/${paxId}/Flight/${flightSectorId}`, flightSector)
      .then((res) => {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function putRail(itineraryId, paxId, railSectorId, railSector) {
    let deferred = $q.defer();

    $http.put(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/Passenger/${paxId}/Rail/${railSectorId}`, railSector)
      .then((res) => {
        let data = res.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function computeBaggageOptions(flight) {
    const baggage = [];
    const ancillaryService = flight.AncillaryServices;

    for (let i = 0; i < ancillaryService.length; i++) {
      if (ancillaryService[i].Type === 'Baggage') {
        baggage.push(ancillaryService[i]);
      }
    }

    flight.baggageOptions = baggage.length > 0 ? [{Description: 'No baggage required', Code: 'empty'}].concat(baggage) : baggage;
    return flight;
  }

  function computeSelectedBaggage(flight) {
    let baggage = null;
    const ancillaryServices = flight.AncillaryServices;

    _.forEach(ancillaryServices, function (ancillaryService) {
      if (ancillaryService.Type === 'Baggage' && ancillaryService.QuantitySelected > 0)
        baggage = ancillaryService;
    });

    baggage = baggage || {Description: 'Select Additional Baggage', Code: 'empty'};

    flight.selectedBaggage = baggage;
    return flight;
  }

  function computeSeatOptions(flight) {
    const ancillaryServices = flight.AncillaryServices;
    const stops = flight.Stops;
    let flights = [];

    const fullFlight = flight;
    const totalStops = stops.length;

    const seats = _.filter(ancillaryServices, function (service) {
      return service.Type === 'Seat';
    });

    let prevLocationCode = totalStops ? stops[0].ArrivalCode : fullFlight.Arrival.Code;

    if (seats.length) {
      flights.push({
        Flight: {
          Origin: fullFlight.Departure.Code,
          Destination: prevLocationCode,
          TravelIdentifier: generateId(fullFlight.FlightIdentifier, 0)
        },
        Seats: seats
      });
    }

    _.forEach(stops, (stop, stopIndex) => {
      const stopSeats = _.filter(stop.AncillaryServices, function (service) {
        return service.Type === 'Seat';
      });

      if (stopSeats.length) {
        const isLastStop = stopIndex === totalStops - 1;
        const nextLocationCode = isLastStop ? fullFlight.Arrival.Code : stops[totalStops - 1].ArrivalCode;

        flights.push({
          Flight: {
            Origin: prevLocationCode,
            Destination: nextLocationCode,
            TravelIdentifier: generateId(stop.FlightIdentifier, stopIndex + 1)
          },
          Seats: stopSeats
        });
      }
    });

    function generateId(flightId, flightIndex) {
      return fullFlight.PassengerIdentifier + flightIndex + flightId;
    }

    flight.seatOptions = flights;
    return flight;
  }

  function computeSeatPreferences(rail) {
    const seatPreferenceTypes = ENUMS.railSeatPreferenceTypes;

    rail.SeatPreferences = {};

    _.forIn(seatPreferenceTypes, (preferenceType) => {
      rail.SeatPreferences[preferenceType] = _.filter(rail.AncillaryServices, (service) => {
        return service.Type === preferenceType;
      });

      rail.SeatPreferences[preferenceType] = _.orderBy(rail.SeatPreferences[preferenceType], (service) => {
        return service.Code === 'No Preference' ? 0 : 1;
      });
    });

    return rail;
  }

  function computeSeatsTotalAmount(flight) {
    flight.seatsTotalAmount = _.reduce(flight.seatOptions, function (total, options) {
      let selectedSeat = _.find(options.Seats, function (seat) {
        return seat.QuantitySelected === 1;
      });

      return total + (selectedSeat ? selectedSeat.Amount : 0);
    }, 0);

    return flight;
  }

  function computeFlightTotalAmount(flight) {
    const ancillaryServices = flight.AncillaryServices;
    const feeAmount = flight.FeeAmount;
    const amount = flight.Amount;
    const stops = flight.Stops;

    let flightTotalAmount = 0;

    _.forEach(ancillaryServices, function (service) {
      flightTotalAmount += service.QuantitySelected * service.Amount;
    });

    _.forEach(stops, function (stop) {
      _.forEach(stop.AncillaryServices, function (service) {
        flightTotalAmount += service.QuantitySelected * service.Amount;
      });
    });

    flight.flightTotalAmount = flightTotalAmount + amount + feeAmount;
    return flight;
  }

  function computeFlightSector(sector) {
    return _.flowRight(computeFlightTotalAmount, computeSeatsTotalAmount, computeSeatOptions, computeSelectedBaggage,
      computeBaggageOptions)(sector);
  }

  function computePaxFlightTotalAmount(pax) {
    let CreditsUsed = 0;
    const flights = pax.Flights;

    _.forEach(flights, function (flight) {
      CreditsUsed += flight.CreditsUsed;
    });

    return CreditsUsed;
  }

  function computePaxSectors(pax) {
    const flights = pax.Flights;
    const rails = pax.Rails;
    const hotels = pax.Hotels;
    const cars = pax.Cars;

    const noTimezoneDateFormat = 'YYYY-MM-DDTHH:mm';
    const sortingDateFormat = 'YYYYMMDDHHmm';
    const groupingDateFormat = 'YYYYMMDD';
    const groupingDateDisplayFormat = 'ddd, DD MMM';

    const sectorsArray = [].concat(flights || [], rails || [], hotels || [], cars || []);

    for (let x = 0; x < sectorsArray.length; x++) {
      let parsedDate = null;

      try {
        if (sectorsArray[x].Departure && sectorsArray[x].Departure.Date) {
          parsedDate = moment(sectorsArray[x].Departure.Date, noTimezoneDateFormat);
        } else if (sectorsArray[x].DateFrom) {
          parsedDate = moment(sectorsArray[x].DateFrom, noTimezoneDateFormat);
        } else if (sectorsArray[x].PickUp && sectorsArray[x].PickUp.Date) {
          parsedDate = moment(sectorsArray[x].PickUp.Date, noTimezoneDateFormat);
        }
      } catch (err) {
      }

      sectorsArray[x].groupByDate = parsedDate ? parsedDate.format(sortingDateFormat) : null;
    }

    sectorsArray.sort(function (sectorA, sectorB) {
      return sectorA.groupByDate > sectorB.groupByDate ? 1 : -1;
    });

    let groupByDateString = null;
    let groupId = 0;
    let unorderedSectors = [];

    for (var y = 0; y < sectorsArray.length; y++) {
      let groupByDate = sectorsArray[y].groupByDate;
      let trimmedGroupByDate = null;
      let groupCopy = {};

      if (groupByDate) {
        trimmedGroupByDate = groupByDate.substring(0, groupByDate.length - 4);
      }

      if (trimmedGroupByDate && groupByDateString !== trimmedGroupByDate) {
        groupId++;
        groupByDateString = trimmedGroupByDate;
        sectorsArray[y].groupByDateString =
          moment(groupByDateString, groupingDateFormat).format(groupingDateDisplayFormat);
      }

      groupCopy = sectorsArray[y];
      groupCopy.groupId = groupId;
      unorderedSectors.push(groupCopy);
    }

    const matchGroupIds = function (array) {
      const x = [];
      angular.forEach(array, function (obj) {
        x.push(obj.groupId)
      });
      return x;
    };

    const onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    const spiltArray = function (array, argumentArray) {
      const result = [];
      let argumentIndex = 0;
      angular.forEach(array, function (obj) {
        if (obj.groupId !== argumentArray[argumentIndex]) {
          argumentIndex++;
        }
        if (!result[argumentIndex]) {
          result[argumentIndex] = [obj];
        } else {
          result[argumentIndex].push(obj);
        }
      });
      return result;
    };

    const reorderParentChild = function (parent) {
      let ParentReordered = [];

      angular.forEach(parent, function (obj) {
        const flights = pluckNamedObjectFromArray(obj, 'Flight');
        const rails = pluckNamedObjectFromArray(obj, 'Rail');
        const hotels = pluckNamedObjectFromArray(obj, 'Hotel');
        const cars = pluckNamedObjectFromArray(obj, 'Car');
        let childReordered = flights.concat(rails, hotels, cars);
        ParentReordered.push(childReordered);
      });

      return ParentReordered;
    };

    const pluckNamedObjectFromArray = function (array, match) {
      let matches = [];
      angular.forEach(array, function (obj) {
        if (match === 'Flight' && obj.Carrier && !obj.RailNumber) {
          matches.push(obj);
        }
        if (match === 'Rail' && obj.RailNumber) {
          matches.push(obj);
        }
        if (match === 'Hotel' && obj.HotelCode) {
          matches.push(obj);
        }
        if (match === 'Car' && obj.PickUp) {
          matches.push(obj);
        }
      });
      return matches;
    };

    const moveAttributeToIndex = function (array, attr) {
      let val = '';

      angular.forEach(array, function (childArray, key) {
        angular.forEach(childArray, function (obj, index) {
          if (obj[attr]) {
            val = obj[attr];
            delete array[key][index][attr];
          }
          array[key][0][attr] = val;
        });
      });

      return array;
    };

    const groupsToOrder = matchGroupIds(unorderedSectors);
    const uniqueGroups = groupsToOrder.filter(onlyUnique);
    const groupByDay = spiltArray(unorderedSectors, uniqueGroups);
    const reorderSectorsInDay = reorderParentChild(groupByDay);
    const moveGroupDate = moveAttributeToIndex(reorderSectorsInDay, 'groupByDateString');

    pax.Sectors = [].concat.apply([], moveGroupDate);
    return pax;
  }

  function computePaxFlightTotal(pax) {
    const flights = pax.Flights;
    let flightTotal = 0;

    _.forEach(flights, function (flight) {
      flightTotal += flight.TotalAmount;
    });

    pax.FlightTotal = flightTotal;
    return pax;
  }

  function computePaxRailTotal(pax) {
    const rails = pax.Rails;
    let railTotal = 0;

    _.forEach(rails, function (rail) {
      railTotal += rail.TotalAmount;
    });

    pax.RailTotal = railTotal;
    return pax;
  }

  function computePaxHotelTotal(pax) {
    const hotels = pax.Hotels;
    let hotelTotal = 0;

    _.forEach(hotels, function (hotel) {
      hotelTotal += hotel.TotalAmount;
    });

    pax.HotelTotal = hotelTotal;
    return pax;
  }

  function computePaxCarTotal(pax) {
    const cars = pax.Cars;
    let carTotal = 0;

    _.forEach(cars, function (car) {
      carTotal += car.TotalAmount;
    });

    pax.CarTotal = carTotal;
    return pax;
  }

  function computePaxAmount(pax) {
    const flightTotal = pax.FlightTotal;
    const RailTotal = pax.RailTotal;
    const hotelTotal = pax.HotelTotal;
    const carTotal = pax.CarTotal;

    pax.Amount = Number(flightTotal) +
      Number(RailTotal) +
      Number(hotelTotal) +
      Number(carTotal);

    return pax;
  }

  function computePaxFlightLostSavingsTotal(pax) {
    const flights = pax.Flights;
    let lostSavingsTotal = 0;

    _.forEach(flights, function (flight) {
      lostSavingsTotal += flight.LostSavingsAmount;
    });

    pax.RailLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeRailLostSavingsTotal(pax) {
    const rails = pax.Rails;
    let lostSavingsTotal = 0;

    _.forEach(rails, function (rail) {
      lostSavingsTotal += rail.LostSavingsAmount;
    });

    pax.RailLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeHotelLostSavingsTotal(pax) {
    const hotels = pax.Hotels;
    let lostSavingsTotal = 0;

    _.forEach(hotels, function (hotel) {
      lostSavingsTotal += hotel.LostSavingsAmount;
    });

    pax.CarLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeCarLostSavingsTotal(pax) {
    const cars = pax.Cars;
    let lostSavingsTotal = 0;

    _.forEach(cars, function (car) {
      if (typeof (car.LostSavingsAmount) === 'number') {
        lostSavingsTotal += car.LostSavingsAmount;
      }
    });

    pax.CarLostSavingsTotal = lostSavingsTotal;
    return pax;
  }

  function computeLostSavingsAmount(pax) {
    pax.LostSavingsAmount = Number(pax.FlightLostSavingsTotal) +
      Number(pax.RailLostSavingsTotal) +
      Number(pax.HotelLostSavingsTotal) +
      Number(pax.CarLostSavingsTotal);

    return pax;
  }

  function computeCreditsUsed(pax) {
    const flights = pax.Flights;
    let creditsUsedTotal = 0;

    if (Array.isArray(flights) && flights.length) {
      _.forEach(flights, function (flight) {
        if (typeof (flight.CreditsUsed) === 'number') {
          creditsUsedTotal += flight.CreditsUsed;
        }
      });
    }

    pax.CreditsUsed = creditsUsedTotal;
    return pax;
  }

  function computeHasFlightSectors(pax) {
    let hasFlights = false;
    if (!!pax && !!pax.Sectors && pax.Sectors.length > 0) {
      for (let i = 0; i < pax.Sectors.length; i++) {
        hasFlights = !!pax.Sectors[i].FlightNumber || hasFlights;
      }
    }

    pax.hasFlights = true;
    return pax;
  }


  function deletePax(paxId, itineraryId) {
    let deferred = $q.defer();

    $http.delete(`${APP_CONFIG.api.url}Itinerary/${itineraryId}/passenger/${paxId}`)
      .then(() => {
        getItinerary(itineraryId).then((res) => {
          deferred.resolve(res);
        });
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function computePax(pax) {
    pax.Flights = pax.Flights.map(flight => {
      return computeFlightSector(flight)
    });

    pax.Rails = pax.Rails.map(rail => {
      return computeRailSector(rail);
    });

    return pax;
  }

  function computeTicketOptions(sector) {
    const ancillaryServices = sector.AncillaryServices;
    
    let options = _.filter(ancillaryServices, function(service) {
      return service.Type === 'Ticketing';
    });

    sector.ticketOptions = _.map(options, (option) => {
      if(option.Description === 'Collection') {
        option.Description = `Pickup on departure - ${sector.Departure.Location} (${sector.Departure.Code})`;
      }

      return option;
    });

    return sector;
  }

  function computeItineraryTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let itineraryTotal = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof (traveler.Amount) === 'number') {
          itineraryTotal += (traveler.Amount);
        }
      });
    }

    itinerary.ItineraryTotal = itineraryTotal;

    return itinerary;
  }

  function computeCreditsUsedTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let totalCreditsUsed = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof (traveler.CreditsUsed) === 'number') {
          totalCreditsUsed += traveler.CreditsUsed;
        }
      });
    }

    itinerary.CreditsUsedTotal = totalCreditsUsed;

    return itinerary;
  }

  function computeLostSavingsTotal(itinerary) {
    const travelers = itinerary.Passengers;
    let lostSavingsTotal = 0;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        if (typeof (traveler.LostSavingsAmount) === 'number') {
          lostSavingsTotal += traveler.LostSavingsAmount;
        }
      });
    }

    itinerary.LostSavingsTotal = lostSavingsTotal;

    return itinerary;
  }

  function computeNonRefundableContent(itinerary) {
    const travelers = itinerary.Passengers;
    let NonRefundable = false;

    if (Array.isArray(travelers)) {
      _.forEach(travelers, function (traveler) {
        let continueLoop = true;
        _.forEach(traveler.Sectors, function (sector) {
          if (sector.Refundable === false) {
            NonRefundable = true;
            continueLoop = false;
            return false;
          }
        });

        return continueLoop
      });
    }

    itinerary.NonRefundableContent = NonRefundable;

    return itinerary;
  }

  function computeRailSector(sector) {
    return _.flowRight(computeTicketOptions, computeSeatPreferences)(sector);
  }

  function computeItinerary(itinerary) {
    if (!itinerary.Passengers && itinerary.Passengers.length === 0) {
      return itinerary;
    }

    itinerary.Passengers.map((pax) => {
      return _.flowRight(computeHasFlightSectors, computeCreditsUsed, computeLostSavingsAmount,
        computeCarLostSavingsTotal, computeHotelLostSavingsTotal, computeRailLostSavingsTotal,
        computePaxFlightLostSavingsTotal, computePaxAmount, computePaxCarTotal, computePaxHotelTotal,
        computePaxRailTotal, computePaxFlightTotal, computePaxSectors, computePax)(pax);
    });

    return _.flowRight(computeNonRefundableContent, computeLostSavingsTotal, computeCreditsUsedTotal,
      computeItineraryTotal)(itinerary);
  }

  function requiresApproval(itinerary) {
    return _.some(itinerary.Passengers, (pax) => {
      return ['Passive', 'PreTrip'].indexOf(pax.ApprovalLevel) > -1;
    });
  }

  return service;
};

itinerariesService.$inject = $inject;

export default itinerariesService;



// WEBPACK FOOTER //
// ./src/services/itinerariesService.js